import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import { TextField, Button } from "@mui/material";
import { RxCross1 } from "react-icons/rx";

const RankingModal = ({
  open,
  onClose,
  defaultValues,
  onSubmit,
  saving = false,
  cloneid,
}) => {
  const [values, setValues] = useState({
    rootsRanking: "",
    plantHealthRanking: "",
    developmentRanking: "",
  });

  useEffect(() => {
    if (open) {
      setValues({
        rootsRanking: defaultValues?.rootsRanking || "",
        plantHealthRanking: defaultValues?.plantHealthRanking || "",
        developmentRanking: defaultValues?.developmentRanking || "",
      });
    }
  }, [open, defaultValues]);

  return (
    <Modal open={open} onClose={onClose}>
      <div className="modal_block" style={{ maxWidth: 520, width: "90vw" }}>
        <div className="modal_header">
          <div className="modal_title_wrapper">
            <h2 className="modal_title">Ranking</h2>
            <h3>Clone ID : {cloneid}</h3>
          </div>
          <div className="cancel-btn-wrap">
            <RxCross1 onClick={onClose} />
          </div>
        </div>
        <div className="modal_content">
          <div className="row">
            <div className="col-md-12">
              <div className="form_field_wrapper m-0">
                <label>Roots Ranking</label>
                <TextField
                  type="number"
                  fullWidth
                  size="small"
                  margin="dense"
                  value={values.rootsRanking}
                  onChange={(e) =>
                    setValues((prev) => ({
                      ...prev,
                      rootsRanking: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form_field_wrapper m-0">
                <label>Plant Health Ranking</label>
                <TextField
                  type="number"
                  fullWidth
                  size="small"
                  margin="dense"
                  value={values.plantHealthRanking}
                  onChange={(e) =>
                    setValues((prev) => ({
                      ...prev,
                      plantHealthRanking: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form_field_wrapper m-0">
                <label>Development Ranking</label>
                <TextField
                  type="number"
                  fullWidth
                  size="small"
                  margin="dense"
                  value={values.developmentRanking}
                  onChange={(e) =>
                    setValues((prev) => ({
                      ...prev,
                      developmentRanking: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal_footer">
          <button onClick={onClose} className="btn btn-border">
            Cancel
          </button>
          <button
            onClick={() => onSubmit?.(values)}
            className="btn btn-primary"
            disabled={saving}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RankingModal;
